import React, { useState } from 'react';
import ScorecardGrid from '../components/scorecard/ScorecardGrid';
import './Scorecard.css';
import PageShell from '../components/layout/PageShell';
import LeagueTable from '../components/scorecard/LeagueTable';
import Methodology from '../components/scorecard/Methodology';

type ViewType = 'scorecard' | 'league-tables' | 'methodology' | null;

const Scorecard: React.FC = () => {
  const [activeView, setActiveView] = useState<ViewType>("scorecard");

  const handleNavClick = (view: ViewType): void => {
    setActiveView((prev) => (prev === view ? null : view));
  };

  return (
    <PageShell>

      <nav className="nav-bar">
        <div
          className={`nav-item ${activeView === "scorecard" ? "active" : ""}`}
          onClick={() => handleNavClick("scorecard")}
        >
          Scorecard
        </div>
        <div
          className={`nav-item ${activeView === "league-tables" ? "active" : ""}`}
          onClick={() => handleNavClick("league-tables")}
        >
          League Table
        </div>
        <div
          className={`nav-item ${activeView === "methodology" ? "active" : ""}`}
          onClick={() => handleNavClick("methodology")}
        >
          Methodology
        </div>
      </nav>

      <div className="view-stack">
        <div className={`view-pane ${activeView === "scorecard" ? "is-active" : ""}`}>
          <div className="content-container-scorecard">
            <button className="close-button" onClick={() => setActiveView(null)}>×</button>
            <ScorecardGrid p_type="traders" />
          </div>
        </div>

        <div className={`view-pane ${activeView === "league-tables" ? "is-active" : ""}`}>
          <div className="content-container-scorecard">
            <button className="close-button" onClick={() => setActiveView(null)}>×</button>
            <div>
              <ScorecardGrid p_type="teams" />
            </div>
            <div>
              <ScorecardGrid p_type="traders" />
            </div>
          </div>
        </div>

        <div className={`view-pane ${activeView === "methodology" ? "is-active" : ""}`}>
          <div className="content-container-scorecard">
            <button className="close-button" onClick={() => setActiveView(null)}>×</button>
            <Methodology />
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default Scorecard;
